import axios from 'axios'

const baseURL =
  process.env.NODE_ENV === 'production'
    ? 'https://mystrengths.umn.edu/api'
    : 'http://localhost:1337/api'

export default axios.create({ baseURL })
